/**
 * Sens reverse
 * @type {{icon: string, label: string, value: string}}
 */
export const RONDE_GRANTED_DIRECTION_REVERSE = { value: '1', label: 'Sens inverse', icon: 'fa fa-backward' }

/**
 * Sens random
 * @type {{icon: string, label: string, value: string}}
 */
export const RONDE_GRANTED_DIRECTION_RANDOM = { value: '2', label: 'Sens aléatoire', icon: 'fa fa-random' }

/**
 * Sens de circulation des rondes
 * @type {[]}
 */
export const RONDES_GRANTED_DIRECTIONS = [
  RONDE_GRANTED_DIRECTION_REVERSE,
  RONDE_GRANTED_DIRECTION_RANDOM
]

/**
 * Sens de circulation indexé par value
 */
export const RONDES_INDEXED_GRANTED_DIRECTIONS = _.keyBy(RONDES_GRANTED_DIRECTIONS, 'value')

/**
 * Ronde libre
 * @type {{name: string}}
 */
export const RONDE_LIBRE = {
  id: null,
  reference: null,
  name: 'Ronde libre'
}
